import { render, staticRenderFns } from "./Float.vue?vue&type=template&id=66bfe876&scoped=true"
import script from "./Float.vue?vue&type=script&lang=js"
export * from "./Float.vue?vue&type=script&lang=js"
import style0 from "./Float.vue?vue&type=style&index=0&id=66bfe876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bfe876",
  null
  
)

export default component.exports